import { ButtonStyled } from '@OnArk/styles/Buttons.styled';
import { DefaultInputStyled } from '@OnArk/styles/Form.styled';

import React from 'react';

import { useSection } from '@OnArk/contexts/section';
import Icon from '@OnArk/SVGs/Icon';
import useRouteState from '@OnArk/utils/useRouteState';

function NewTeamInput() {
  const { client, setTeams } = useSection();

  const [showNewTeam, setShowNewTeam] = useRouteState(false);
  const saveTeam = async (name: string) => {
    if (!name) return;
    const { data: team } = await client.createMinistry({
      data: { church: { connect: { id: 'CHURCH_ID' } }, name },
    });

    setTeams(t => [...(t ?? []), team]);
    setShowNewTeam(false);
  };

  return (
    <>
      {!showNewTeam && (
        <ButtonStyled
          outline
          withIcon
          left="0"
          top="1"
          onClick={() => setShowNewTeam(true)}
        >
          <Icon name="ACTIONS_Add" size="20" /> Add Ministry
        </ButtonStyled>
      )}
      {showNewTeam && (
        <div
          css={{
            alignItems: 'center',
            display: 'flex',
            marginTop: '1rem',
          }}
        >
          <DefaultInputStyled
            autoFocus
            placeholder="New Ministry Name"
            onKeyDown={event => {
              if (event.key === 'Enter') {
                const input = event.target as HTMLInputElement;

                void saveTeam(input.value);
                input.value = '';
              }
            }}
          />
          <button
            css={{ marginLeft: '-3rem' }}
            type="button"
            onClick={() => setShowNewTeam(false)}
          >
            <Icon name="ACTIONS_Close" size="20" />
          </button>
          <ButtonStyled
            css={theme => ({
              borderRadius: theme.radius.md,
              marginLeft: '1rem',
              padding: '0.8rem 1rem',
            })}
            withIcon="only"
            onClick={e => {
              const target = e.currentTarget;
              const input = target?.previousSibling
                ?.previousSibling as HTMLInputElement;

              void saveTeam(input.value);
              input.value = '';
              setShowNewTeam(false);
            }}
          >
            <Icon name="CIRCLE_Completed" right="0" size="20" />
          </ButtonStyled>
        </div>
      )}
    </>
  );
}

export default NewTeamInput;
